import { render, staticRenderFns } from "./dataManage.vue?vue&type=template&id=2e392bb0"
import script from "./dataManage.vue?vue&type=script&lang=js"
export * from "./dataManage.vue?vue&type=script&lang=js"
import style0 from "./dataManage.vue?vue&type=style&index=0&id=2e392bb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports